import { apiGet } from '../standardApi';

export async function apiGetUserContracts() {
  const response = await apiGet(`/Contracts`);
  return response;
}
